import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import CancelledTrialMembersPageHeader from './components/CancelledTrialMembersPageHeader';
import CancelledTrialMembersTable from './components/CancelledTrialMembersTable';
import { SearchFilters } from './types';

const CancelledTrialMembers = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();
  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-trialCancelDate');

  return (
    <>
      <CancelledTrialMembersPageHeader
        orderingValue={orderingValue}
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
      />

      <CancelledTrialMembersTable
        searchFilters={debouncedSearchFilters}
        setOrderingValue={setOrderingValue}
      />
    </>
  );
};

export default CancelledTrialMembers;
